const additionalServiceTowel = document.querySelector("[data-js='additionalServiceTowel']");
const additionalServiceTowelInput = document.querySelector("#f-additional-service-towel");
const additionalServiceTowelSubmit = document.querySelector("#submit-additional-service-towel");
const additionalServiceTowelReset = document.querySelector("#reset-additional-service-towel");

const asTowelSubsBtn = document.querySelector("#as-towel-subs-btn");
const asTowelAddBtn = document.querySelector("#as-towel-add-btn");
const asTowelCountEl = document.querySelector("#as-towel-count");

let asCount = 0;

if (additionalServiceTowel) {

	additionalServiceTowelSubmit.addEventListener("click", function () {
		let asValues = $("input[type='checkbox']:checked").map(function () {
			return $(this).val();
		}).get().join(", ");

		if (asValues != 0) {
			additionalServiceTowelInput.value = (asValues);
		} else if (asCount != 0) {
			additionalServiceTowelInput.value = asCount + " x Handtuch";
		}

		if (asValues != 0 && asCount != 0) {
			additionalServiceTowelInput.value = (asValues) + ", " + asCount + " x Handtuch";
		} else if (asValues == 0 && asCount == 0) {
			additionalServiceTowelInput.value = "";
		}
	});

	additionalServiceTowelReset.addEventListener("click", function () {
		$("input[type='checkbox']:checked").prop("checked", false);
		asCount = 0;
		updateCountValues();
		additionalServiceTowelInput.value = "";
	});

	updateCountValues();

	asTowelAddBtn.addEventListener("click", function () {
		asCount = addValues(asCount);
		updateCountValues();
	});
	asTowelSubsBtn.addEventListener("click", function () {
		asCount = substractValues(asCount, 0);
		updateCountValues();
	});

	function addValues(count) {
		return count + 1;
	}

	function substractValues(count, min) {
		return (count > min)
			? count - 1
			: count;
	}

	function updateCountValues() {
		asTowelCountEl.innerHTML = asCount;
		if (asCount == 0) {
            asTowelSubsBtn.classList.add("disabled");
        } else {
            asTowelSubsBtn.classList.remove("disabled");
        }
	}
}